import { chargerManagementService } from "../../helpers/chergerManagementService";

export const state = {
  getShowPublicCharger: [],
  getUpdateStatus: [],
  getAllChargers: [],
  getAllUsers: [],
   getAllManagers: [],
  getAllPublicCharger: [],
  getAllPrivateCharger: [],
  userVehicleCount: "",
  publicChargerCount: "",
  privateChargerCount: "",
  paginations: {},
  loading: true,
  getBookingReportByYear: {},
  getEarningReportByYear: {},
  totalBookingChargingUnit:0,
  totalBookingChargingTime:0
};

export const mutations = {
  getShowPublicCharger(state, payload) {
    state.getShowPublicCharger = payload.result;
    state.loading = false;
  },
  getUser(state, payload) {
    state.getAllUsers = payload.result;
  },
  getManager(state, payload) {  // Changed mutation name
  state.getAllManagers = payload.result;
},
  getBookingReportByYear(state, payload) {
    var result = [];
    payload.data.forEach(function (payload) {
      var data = {
        x: payload.x,
        y: payload.y,
      };
      result.push(data);
    });
    state.getBookingReportByYear = result;
    state.totalBookingChargingUnit = payload.charging_unit;
    state.totalBookingChargingTime = payload.charging_time;
  },

  getEarningReportByYear(state, payload) {
    var result = [];
    payload.forEach(function (payload) {
      var data = {
        x: payload.x,
        y: payload.y,
      };
      result.push(data);
    });
    state.getEarningReportByYear = result;
  },
  getUpdateStatus(state, payload) {
    state.getUpdateStatus = payload;
  },
  getAllChargers(state, payload) {
    state.getAllChargers = payload.result;
  },
  getAllPublicCharger(state, payload) {
    state.getAllPublicCharger = payload.result.data;
    state.loading = false;
    state.paginations = payload.result;
    state.publicChargerCount = payload.result.total;
  },
  getAllPrivateCharger(state, payload) {
    state.getAllPrivateCharger = payload.result.data;
    state.loading = false;
    state.paginations = payload.result;
    state.privateChargerCount = payload.result.total;
  },
  getUserVehicle(state, payload) {
    state.user = payload.result;
  },
  getUserVehicleListFailure(state) {
    state.loading = false;
  },
  getUpdateVehicleMakeFailure(state) {
    state.loading = false;
  },
  getVehicleMakeListRequest(state) {
    state.loading = true;
  },
};

export const actions = {
  async getPublicCharger({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await chargerManagementService.getPublicCharger(data).then(
      (response) => {
        commit("getAllPublicCharger", response.data);
      },
      (error) => {
        commit("getVehicleMakeListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async getPrivateCharger({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await chargerManagementService.getPrivateCharger(data).then(
      (response) => {
        commit("getAllPrivateCharger", response.data);
      },
      (error) => {
        commit("getVehicleMakeListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async showPublicCharger({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await chargerManagementService.showPublicCharger(data).then(
      (response) => {
        commit("getShowPublicCharger", response.data);
      },
      (error) => {
        commit("getVehicleMakeListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async addOrUpdateCharger({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await chargerManagementService.addOrUpdateCharger(data).then((response) => {
      if (response.data.code == 200) {
        dispatch("alert/success", response.data.msg, { root: true });
        commit("getUpdateStatus", response.data.code);
      } else {
        commit("getUpdateVehicleMakeFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },

  async getAllChargersDetail({ commit }) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    await chargerManagementService.getAllChargersDetail().then((response) => {
      commit("getAllChargers", response.data);
      //dispatch("alert/success", response.data.msg, { root: true });
    });
  },

  async deleteCharger({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await chargerManagementService.deleteCharger(data).then((response) => {
      if (response.data.code == 200) {
        dispatch("alert/success", response.data.msg, { root: true });
        commit("getUpdateStatus", response.data.code);
      } else {
        commit("getUpdateVehicleMakeFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },

  async getUsers({ dispatch, commit }, data) {
    console.log("get users has been hit");
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await chargerManagementService.getUsers(data).then((response) => {
      if (response.data.code == 200) {
        commit("getUser", response.data);
      } else {
        commit("getUpdateVehicleMakeFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },
async getManagers({ dispatch, commit }, data = {}) {
  let token = JSON.parse(localStorage.getItem("token"));
  window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  
  commit("getVehicleMakeListRequest");
  try {
    const response = await chargerManagementService.getManagers(data);
    
    // Handle direct array response (no code/result wrapper)
    if (Array.isArray(response.data)) {
      commit("getManager", { result: response.data }); // Wrap in result object
    } 
    // Handle if API changes to use code/result format later
    else if (response.data.code === 200) {
      commit("getManager", response.data);
    } else {
      throw new Error(response.data.msg || "Failed to load managers");
    }
  } catch (error) {
    console.error("Managers API error:", error);
    commit("getUpdateVehicleMakeFailure");
    dispatch("alert/error", error.message, { root: true });
  }
},

  async getMonthWiseBookingReport({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    commit("getVehicleMakeListRequest");
    await chargerManagementService
      .getMonthWiseBooking(data)
      .then((response) => {
        if (response.status == 200) {
          commit("getBookingReportByYear", response.data);
        } else {
          commit("getUpdateVehicleMakeFailure", response.data.data);
          dispatch("alert/error", response.data.msg, { root: true });
        }
      });
  },

  async getMonthWiseEarningReport({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    commit("getVehicleMakeListRequest");
    await chargerManagementService
      .getMonthWiseEarning(data)
      .then((response) => {
        if (response.status == 200) {
          commit("getEarningReportByYear", response.data);
        } else {
          commit("getUpdateVehicleMakeFailure", response.data);
          dispatch("alert/error", response.data.msg, { root: true });
        }
      });
  },
};

export const getters = {
  loading: (state) => state.loading,
  getAllPublicCharger: (state) => state.getAllPublicCharger,
  getAllPrivateCharger: (state) => state.getAllPrivateCharger,
  getShowPublicCharger: (state) => state.getShowPublicCharger,
  getUpdateStatus: (state) => state.getUpdateStatus,
  getAllChargers: (state) => state.getAllChargers,
  publicChargerCount: (state) => state.publicChargerCount,
  privateChargerCount: (state) => state.privateChargerCount,
  getAllUsers: (state) => state.getAllUsers,
  getAllManagers: (state) => state.getAllManagers,
  pagination: (state) => state.paginations,
  getBookingReportByYear: (state) => state.getBookingReportByYear,
  getEarningReportByYear: (state) => state.getEarningReportByYear,
  totalBookingChargingUnit: (state) => state.totalBookingChargingUnit,
  totalBookingChargingTime: (state) => state.totalBookingChargingTime,
};
